<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          {{
            titulo == "interno"
              ? "Listagem de Ativos"
              : titulo == "externo"
              ? "Listagem de Ativos Externos"
              : titulo == "deletado"
              ? "Listagem de Ativos Deletados"
              : ""
          }}
        </p>
      </div>
    </div>
    <div class="container-tabela q-mt-xl">
      <div class="q-mt-xl q-mb-md">
        <ComponenteFiltros
          v-if="titulo == 'interno'"
          :unidade="true"
          :classUnidade="'col-md col-xs-6'"
          :statusMovimentacao="true"
          :classStatusMovimentacao="'col-md col-xs-6'"
          :codigo="true"
          :classCodigo="'col-md col-xs-5'"
          :descricao="true"
          :classDescricao="'col-md col-xs-6'"
          :patrimonio="true"
          :classPatrimonio="'col-md col-xs-5'"
          :classGrupo="'col-md col-xs-6'"
          :subgrupo="true"
          :classSubgrupo="'col-md col-xs-5'"
          @enviarFiltro="receberFiltro"
        />
        <ComponenteFiltros
          v-if="titulo == 'deletado'"
          :unidade="true"
          :classUnidade="'col-md col-xs-6'"
          :codigo="true"
          :classCodigo="'col-md col-xs-5'"
          :descricao="true"
          :classDescricao="'col-md col-xs-6'"
          :patrimonio="true"
          :classPatrimonio="'col-md col-xs-5'"
          :classGrupo="'col-md col-xs-6'"
          :subgrupo="true"
          :classSubgrupo="'col-md col-xs-5'"
          @enviarFiltro="receberFiltro"
        />
        <ComponenteFiltros
          v-if="titulo == 'externo'"
          :unidade="true"
          :classUnidade="'col-md col-xs-6'"
          :fornecedor="true"
          :classFornecedor="'col-md col-xs-5'"
          :codigo="true"
          :classCodigo="'col-md col-xs-6'"
          :descricao="true"
          :classDescricao="'col-md col-xs-5'"
          :patrimonio="true"
          :classPatrimonio="'col-md col-xs-6'"
          :classGrupo="'col-md col-xs-5'"
          :subgrupo="true"
          :statusMovimentacao="true"
          :classStatusMovimentacao="'col-md col-xs-5'"
          :classSubgrupo="'col-md col-xs-6'"
          @enviarFiltro="receberFiltro"
        />
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="
          titulo == 'interno'
            ? columns
            : titulo == 'externo'
            ? columnsFornecedor
            : titulo == 'deletado'
            ? columnsDeletado
            : ''
        "
        :rows="listaFerramentas"
        :hide-bottom="!listaFerramentas.length == 0"
        flat
        dense
        table-header-class="bg-accent text-weight-bold"
        :grid="mobile"
        :class="{ 'my-sticky-dynamic': !mobile }"
        @request="handleRequest"
        no-data-label="Nenhum ativo encontrado."
        binary-state-sort
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-md col-sm-6 col-xs-12">
            <q-card class="container-grid-table col">
              <div class="q-pa-sm">
                <div class="row col-12 container-imagem-grid">
                  <div
                    style="position: relative; width: 100%"
                    v-if="props.row.urlImagem"
                  >
                    <q-img
                      fit="contain"
                      height="240px"
                      width="100%"
                      no-native-menu
                      :src="props.row.urlImagem"
                    >
                    </q-img>
                    <div
                      style="width: 100%; bottom: 0; background: transparent"
                      class="absolute row col-12 justify-between items-center"
                    >
                      <q-icon
                        size="25px"
                        color="secondary"
                        name="article"
                        :disable="disable"
                        @click="
                          (rightDrawerOpen = true),
                            (editarAtivo = { ...props.row }),
                            (dadosEditar = { ...props.row })
                        "
                      ></q-icon>
                      <router-link
                        :to="{
                          name: 'ferramentaria-historico-ativo',
                          params: {
                            ativoUuid: props.row?.ativoUuid,
                            tipoAtivo: titulo,
                          },
                        }"
                      >
                        <q-btn icon="manage_search" color="black" flat round />
                      </router-link>
                      <router-link
                        v-if="titulo == 'interno' || titulo == 'externo'"
                        :to="{
                          name: 'ferramentaria-vinculo-ativo-documento',
                          params: {
                            ativoUuid: props.row.ativoUuid,
                            tipoAtivo: titulo,
                            unidadeId: filtros?.unidade?.id,
                          },
                        }"
                      >
                        <q-btn icon="note_add" color="primary" flat round />
                      </router-link>
                      <q-icon
                        v-if="titulo == 'interno'"
                        size="25px"
                        color="red"
                        name="delete"
                        :disable="disable"
                        @click="
                          (ativoIdExcluir = props.row.ativoUuid),
                            (confirm = true)
                        "
                      ></q-icon>
                    </div>
                  </div>
                  <div style="position: relative; width: 100%" v-else>
                    <q-img
                      fit="contain"
                      height="240px"
                      width="100%"
                      no-native-menu
                      src="../../../assets/semImagem.jpg"
                    >
                      <div
                        style="
                          width: 100%;
                          bottom: 0;
                          background: transparent;
                          padding: 0px;
                        "
                        class="absolute row col-12 justify-between items-center"
                      >
                        <q-icon
                          size="25px"
                          color="secondary"
                          name="article"
                          :disable="disable"
                          @click="
                            (rightDrawerOpen = true),
                              (editarAtivo = { ...props.row }),
                              (dadosEditar = { ...props.row })
                          "
                        ></q-icon>
                        <router-link
                          :to="{
                            name: 'ferramentaria-historico-ativo',
                            params: {
                              ativoUuid: props.row.ativoUuid,
                              tipoAtivo: titulo,
                            },
                          }"
                        >
                          <q-btn
                            icon="manage_search"
                            color="black"
                            flat
                            round
                          />
                        </router-link>
                        <router-link
                          v-if="titulo == 'interno' || titulo == 'externo'"
                          :to="{
                            name: 'ferramentaria-vinculo-ativo-documento',
                            params: {
                              ativoUuid: props.row.ativoUuid,
                              tipoAtivo: titulo,
                              unidadeId: filtros?.unidade?.id,
                            },
                          }"
                        >
                          <q-btn icon="note_add" color="primary" flat round />
                        </router-link>
                        <q-icon
                          v-if="titulo == 'interno'"
                          size="25px"
                          color="red"
                          name="delete"
                          :disable="disable"
                          @click="
                            (ativoIdExcluir = props.row.ativoUuid),
                              (confirm = true)
                          "
                        ></q-icon>
                      </div>
                    </q-img>
                  </div>
                </div>
              </div>
              <div class="row col-12 q-pa-sm q-gutter-xs">
                <div class="row col-12">
                  <span v-if="props.row?.catalogoItem?.codigo?.length < 25"
                    ><strong>Código: </strong
                    >{{ props.row?.catalogoItem?.codigo }}</span
                  >
                  <span v-else
                    ><strong>Código: </strong
                    >{{ props.row?.catalogoItem?.codigo?.substring(0, 25) }}...
                    <q-tooltip>{{
                      props.row?.catalogoItem?.codigo
                    }}</q-tooltip></span
                  >
                </div>
                <div class="row col-12">
                  <span v-if="props.row?.catalogoItem?.nome?.length < 25"
                    ><strong>Descrição: </strong
                    >{{ props.row?.catalogoItem?.nome }}</span
                  >
                  <span v-else
                    ><strong>Descrição: </strong
                    >{{ props.row?.catalogoItem?.nome?.substring(0, 25) }}...
                    <q-tooltip>{{
                      props.row?.catalogoItem?.nome
                    }}</q-tooltip></span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Patrimônio: </strong
                    >{{ props.row?.patrimonio }}</span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Grupo: </strong
                    >{{ props.row?.catalogoItem?.catalogoGrupo?.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Subgrupo: </strong
                    >{{ props.row?.catalogoItem?.catalogoSubGrupo?.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Status: </strong>
                    {{
                      `${props.row?.status
                        ?.charAt(0)
                        .toUpperCase()}${props.row?.status?.substring(1)}`
                    }}</span
                  >
                  <q-tooltip v-if="props.row?.status == 'em_uso'">
                    <span class="row col-12"
                      >Nome: {{ props.row.nomeUsuarioEmprestimo }}</span
                    >
                    <span class="row col-12"
                      >Matricula:
                      {{ props.row.matriculaUsuarioEmprestimo }}</span
                    >
                  </q-tooltip>
                </div>
                <div v-if="titulo == 'externo'" class="row col-12">
                  <span
                    ><strong>Fornecedor: </strong
                    >{{ props.row?.fornecedorAlocadoNome }}</span
                  >
                </div>
                <div v-if="titulo == 'externo'" class="row col-12">
                  <span
                    ><strong>Fornecedor CNPJ: </strong
                    >{{ props.row?.fornecedorAlocadoCnpj }}</span
                  >
                </div>
                <div v-if="titulo == 'deletado'" class="row col-12">
                  <span
                    ><strong>Excluído: </strong
                    >{{ props.row?.nomeUsuarioExclusao }}</span
                  >
                </div>
                <div v-if="titulo == 'deletado'" class="row col-12">
                  <span
                    ><strong>Excluído Em: </strong
                    >{{
                      props.row?.excluidoEm
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                    {{ props.row?.excluidoEm.split(" ")[1] }}</span
                  >
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.catalogoItem?.codigo }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.catalogoItem?.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-patrimonio="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.patrimonio }}
          </q-td>
        </template>
        <template v-slot:body-cell-grupo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.catalogoItem?.catalogoGrupo.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-subgrupo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.catalogoItem?.catalogoSubGrupo?.nome }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              `${props.row?.status
                ?.charAt(0)
                .toUpperCase()}${props.row?.status?.substring(1)}`
            }}
            <q-tooltip v-if="props.row?.status == 'em_uso'">
              <span class="row col-12"
                >Nome: {{ props.row.nomeUsuarioEmprestimo }}</span
              >
              <span class="row col-12"
                >Matricula: {{ props.row.matriculaUsuarioEmprestimo }}</span
              >
            </q-tooltip>
          </q-td>
        </template>
        <template v-slot:body-cell-fornecedor="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.fornecedorAlocadoNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-fornecedorCnpj="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.fornecedorAlocadoCnpj }}
          </q-td>
        </template>
        <template v-slot:body-cell-excluidoPor="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.nomeUsuarioExclusao }}
          </q-td>
        </template>
        <template v-slot:body-cell-excluidoEm="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span>
              {{
                props.row?.excluidoEm
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </span>
            <span class="row q-ml-sm">
              {{ props.row?.excluidoEm.split(" ")[1] }}
            </span>
          </q-td>
        </template>
        <template v-slot:body-cell-imagem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <div
              style="
                border: 1px solid #707070;
                height: 60px;
                width: 60px;
                border-radius: 5px;
              "
            >
              <q-img
                v-if="props.row.urlImagem"
                fit="contain"
                height="100%"
                width="95%"
                :src="props.row.urlImagem"
              />
              <q-img
                v-else
                fit="contain"
                height="100%"
                width="95%"
                src="../../../assets/semImagem.jpg"
              />
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-unidade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.unidadeNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-historico="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'ferramentaria-historico-ativo',
                params: {
                  ativoUuid: props.row.ativoUuid,
                  tipoAtivo: titulo,
                },
              }"
            >
              <q-btn icon="manage_search" color="black" flat round />
            </router-link>
          </q-td>
        </template>
        <template v-slot:body-cell-documento="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'ferramentaria-vinculo-ativo-documento',
                params: {
                  ativoUuid: props.row.ativoUuid,
                  tipoAtivo: titulo,
                  unidadeId: filtros?.unidade?.id,
                },
              }"
            >
              <q-btn icon="note_add" color="primary" flat round />
            </router-link>
          </q-td>
        </template>
        <template v-slot:body-cell-detalhe="props">
          <q-td :props="props">
            <q-btn
              icon="article"
              outline
              color="blue"
              round
              flat
              :disable="disable"
              @click="
                (rightDrawerOpen = true),
                  (editarAtivo = { ...props.row }),
                  (dadosEditar = { ...props.row })
              "
            />
          </q-td>
        </template>
        <template v-slot:body-cell-excluir="props">
          <q-td :props="props">
            <q-btn
              icon="delete"
              outline
              color="red"
              round
              flat
              :disable="disable"
              @click="(ativoIdExcluir = props.row.ativoUuid), (confirm = true)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center justify-between">
            <div class="row items-center">
              <q-icon
                style="cursor: pointer"
                :name="tab === 'inicio' ? 'close' : 'arrow_back_ios'"
                class="q-mr-md icon-modal"
                @click="
                  tab === 'inicio'
                    ? (rightDrawerOpen = false)
                    : (tab = 'inicio')
                "
              />
              <span class="texto-titulo-modal">
                <span>
                  <span>
                    {{
                      tab === "inicio"
                        ? "Editar Ativo"
                        : tab === "atributo"
                        ? "Adicionar Atributos"
                        : tab === "checklist"
                        ? "Adicionar Checklist"
                        : tab === "acessorios"
                        ? "Adicionar Acessórios"
                        : ""
                    }}
                  </span>
                </span>
              </span>
            </div>
            <div
              v-if="tab !== 'checklist'"
              class="justify-end row col-md-12 col-lg-12 col-xs-12 q-mt-xs"
            >
              <div class="row col-12 col-xs-12 container-tab justify-end">
                <q-tabs v-model="tab" narrow-indicator dense align="right">
                  <q-tab
                    class="text-black"
                    no-caps
                    name="atributo"
                    label="Atributos"
                  />
                  <q-tab
                    no-caps
                    class="text-black"
                    name="checklist"
                    label="Checklist"
                    @click="subTab = 'associar'"
                  />
                  <q-tab
                    no-caps
                    class="text-black"
                    name="acessorios"
                    label="Acessórios"
                  />
                </q-tabs>
              </div>
            </div>
            <div v-else class="row col-xs-12 col-md-2 col-lg-2 justify-end">
              <div class="row col-2 justify-end container-tab">
                <q-tabs v-model="subTab" narrow-indicator dense align="right">
                  <q-tab
                    class="text-black"
                    no-caps
                    name="associar"
                    label="Associar"
                  />
                  <q-tab
                    class="text-black"
                    no-caps
                    name="adicionar"
                    label="Adicionar"
                  />
                </q-tabs>
              </div>
            </div>
          </div>
        </div>
        <q-scroll-area v-if="tab === 'inicio'" style="width: 100%; height: 85%">
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Código</div>
                <q-input
                  class="input-modal"
                  v-model="editarAtivo.catalogoItem.codigo"
                  dense
                  maxlength="50"
                  outlined
                  disable
                  bg-color="brand-7"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Descrição</div>
                <q-input
                  class="input-modal"
                  v-model="editarAtivo.catalogoItem.nome"
                  dense
                  maxlength="255"
                  outlined
                  disable
                  bg-color="brand-7"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Patrimônio</div>
                <q-input
                  class="input-modal"
                  v-model="editarAtivo.patrimonio"
                  dense
                  maxlength="255"
                  outlined
                  :disable="
                    !permissaoEditar || editarAtivo.status != 'disponivel'
                  "
                  :bg-color="
                    permissaoEditar && editarAtivo.status == 'disponivel'
                      ? ''
                      : 'brand-7'
                  "
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">
                  Tempo de Permanencia
                </div>
                <q-input
                  v-model="editarAtivo.tempoPermanencia"
                  dense
                  class="input-modal"
                  outlined
                  type="number"
                  :bg-color="
                    permissaoEditar && editarAtivo.status == 'disponivel'
                      ? ''
                      : 'brand-7'
                  "
                  :disable="
                    !permissaoEditar || editarAtivo.status != 'disponivel'
                  "
                  min="1"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Preço</div>
                <InputFormatarPreco
                  v-model="editarAtivo.preco"
                  :disable="
                    !permissaoEditar || editarAtivo.status != 'disponivel'
                  "
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Valor Locação</div>
                <InputFormatarPreco
                  v-model="editarAtivo.valorLocacao"
                  :disable="
                    !permissaoEditar || editarAtivo.status != 'disponivel'
                  "
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Fornecedor Compra</div>
                <SelecaoFornecedor
                  :desabilitado="
                    !permissaoEditar || editarAtivo.status == 'disponivel'
                  "
                  :unidadeId="filtros?.unidade?.id"
                  :model="{
                    id: editarAtivo?.fornecedorId,
                    nome: editarAtivo?.fornecedorNome,
                    cnpj: editarAtivo?.fornecedorCnpj,
                  }"
                  @enviarFornecedor="receberFornecedor"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">
                  Fornecedor Compra CNPJ
                </div>
                <q-input
                  v-model="editarAtivo.fornecedorCnpj"
                  dense
                  class="input-modal"
                  outlined
                  disable
                  bg-color="brand-7"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Grupo</div>
                <SelecaoGrupo
                  :grupoUuid="
                    editarAtivo?.catalogoItem?.catalogoGrupo?.catalogoGrupoUuid
                  "
                  @enviarGrupo="receberGrupo"
                  :disable="true"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Sub Grupo</div>
                <SelecaoSubgrupo
                  :grupoUuid="
                    editarAtivo?.catalogoItem?.catalogoGrupo?.catalogoGrupoUuid
                  "
                  :model="editarAtivo?.catalogoItem?.catalogoSubGrupo"
                  :disable="true"
                  @enviarSubgrupo="receberSubgrupo"
                />
              </div>
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Imagem</div>
                <div style="position: relative" class="container-imagem">
                  <q-img
                    class="imagem-ferramenta"
                    fit="contain"
                    :src="editarAtivo.urlImagem"
                  >
                    <div class="file-container">
                      <q-file
                        style="width: 100% !important; height: 200px"
                        borderless
                        type="file"
                        v-model="img"
                      >
                        <div
                          class="row col-12 justify-center items-center file"
                        >
                          <span
                            v-if="
                              editarAtivo.urlImagem == null ||
                              editarAtivo.urlImagem == ''
                            "
                            class="texto-alterar-imagem"
                            >{{
                              editarAtivo.urlImagem == null ||
                              editarAtivo.urlImagem == ""
                                ? "Adicionar Imagem"
                                : ""
                            }}</span
                          >
                        </div>
                      </q-file>
                    </div>
                  </q-img>
                  <div
                    v-if="
                      editarAtivo.urlImagem != '' &&
                      img?.name == undefined &&
                      editarAtivo.urlImagem != imageUrl &&
                      editarAtivo.urlImagem != null
                    "
                    style="
                      width: 100%;
                      top: 0;
                      background: transparent;
                      cursor: pointer;
                    "
                    class="absolute row col-12 justify-between items-center"
                    @click="excluirImagem()"
                  >
                    <q-icon
                      class="absolute all-pointer-events"
                      size="25px"
                      color="red"
                      style="top: 8px; right: 16px; z-index: 30"
                      name="delete"
                    ></q-icon>
                  </div>
                </div>
              </div>
            </div>
            <div class="q-px-md q-mt-md q-pb-md btn-editar-container">
              <q-btn
                class="q-mt-sm btn-modal"
                icon="check_circle_outlined"
                label="Salvar"
                no-caps
                color="positive"
                @click="
                  editarAtivo.status == 'disponivel'
                    ? editarInformacoesAtivo()
                    : fazerUploadImagem()
                "
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'checklist'"
          style="max-width: 100%; height: 85%"
        >
          <div
            class="row col-12"
            style="height: 100%"
            v-if="subTab === 'associar'"
          >
            <div class="q-px-md col-12 text-weight-bold q-mb-md">
              <div class="row col-12 q-mt-xs items-center q-mb-lg">
                <div class="col">
                  <div class="texto-titulo-input q-mb-xs">Checklist</div>
                  <SelecaoChecklist
                    @enviarChecklist="receberChecklist"
                    :multiple="false"
                    :resetar="resetarChecklist"
                  />
                </div>
                <div>
                  <p></p>
                  <q-btn
                    icon="add"
                    flat
                    class="q-mt-xs q-ml-sm"
                    round
                    color="primary"
                    :disable="disableChecklist"
                    @click="associarChecklist(checklist?.checkListUuid)"
                  />
                </div>
              </div>
              <div>
                <div class="texto-titulo-tabela">
                  Lista de Checklist Associados
                </div>
                <div
                  v-for="(checklist, index) in listaChecklist"
                  :key="index"
                  class="row q-mt-xs q-pa-sm items-center justify-between"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div
                    style="
                      width: 80%;
                      word-wrap: break-word;
                      word-break: break-all;
                    "
                  >
                    <span class="row col-12 texto-conteudo-tabela">
                      {{ index + 1 }} - {{ checklist.nome }}
                    </span>
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm icon-tabela"
                      :disable="disableChecklist"
                      @click="desassociarChecklist(checklist.checkListUuid)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
            v-if="subTab === 'adicionar'"
          >
            <div class="q-px-md text-weight-bold">
              <div class="col-md-12 q-mt-xs">
                <div class="texto-titulo-input q-mb-xs">Nome</div>
                <q-input
                  class="input-modal"
                  v-model="checklistCriar.nome"
                  dense
                  :rules="[validacaoCaracteresChecklist]"
                  hide-bottom-space
                  outlined
                  maxlength="255"
                />
              </div>
            </div>
            <div class="q-px-md q-mt-md q-pb-md btn-editar">
              <q-btn
                class="q-mt-sm btn-modal"
                icon="check_circle_outlined"
                label="Criar"
                no-caps
                color="positive"
                @click="criarChecklist()"
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'atributo'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="row col-md-12 q-mt-xs q-mb-lg">
                <div class="col-md-3 col-xs">
                  <div class="texto-titulo-input q-mb-xs">Chave</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAtributo[0].chave"
                    dense
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                    outlined
                  />
                </div>
                <div class="col-md col-xs-4 q-ml-xs">
                  <div class="texto-titulo-input q-mb-xs">Valor</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAtributo[0].valor"
                    dense
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                    outlined
                  />
                </div>
                <div>
                  <q-btn
                    icon="add"
                    dense
                    flat
                    round
                    color="primary"
                    :disable="disableAtributo"
                    class="q-ml-sm icon"
                    @click="adicionarAtributo()"
                  />
                </div>
              </div>
              <div>
                <div class="texto-titulo-tabela">
                  Lista de Atributos Criados
                </div>
                <div
                  v-for="(atributo, index) in atributosFerramentas"
                  :key="index"
                  class="row col-md-12 q-mt-xs q-pa-sm items-center"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div class="col-10">
                    <div
                      class="row col-12 justify-between texto-conteudo-tabela"
                      style="
                        word-wrap: break-all;
                        width: 90%;
                        word-break: break-all;
                      "
                    >
                      <span class="col"
                        >{{ index + 1 }}- <strong>Chave:</strong>
                        {{ atributo.chave }}</span
                      >
                      <span class="col"
                        ><strong class="q-mr-xs">Valor:</strong>
                        {{ atributo.valor }}</span
                      >
                    </div>
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm"
                      :disable="disableAtributo"
                      @click="excluirAtributo(atributo.chave)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area
          v-if="tab === 'acessorios'"
          style="width: 100%; height: 85%"
        >
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div class="q-px-md text-weight-bold">
              <div class="row col-md-12 q-mt-xs q-mb-lg">
                <div class="col-md col-xs">
                  <div class="texto-titulo-input q-mb-xs">Nome</div>
                  <q-input
                    class="input-modal"
                    v-model="dadoAcessorio[0].nome"
                    dense
                    :rules="[validacaoCaracteresEspeciais]"
                    hide-bottom-space
                    outlined
                  />
                </div>
                <div>
                  <q-btn
                    icon="add"
                    dense
                    flat
                    round
                    color="primary"
                    :disable="disableAcessorio"
                    class="q-ml-sm icon"
                    @click="adicionarAcessorio()"
                  />
                </div>
              </div>
              <div>
                <div class="texto-titulo-tabela">
                  Lista de Acessórios Criados
                </div>
                <div
                  v-for="(acessorio, index) in editarAtivo?.acessorios"
                  :key="index"
                  class="row col-md-12 q-mt-xs q-pa-sm items-center"
                  style="border: 1px solid; border-radius: 5px"
                >
                  <div class="col-10">
                    <div
                      class="row col-12 justify-between texto-conteudo-tabela"
                      style="
                        width: 90%;
                        word-wrap: break-all;
                        word-break: break-all;
                      "
                    >
                      <span class="col"
                        >{{ index + 1 }}- <strong>Nome:</strong>
                        {{ acessorio.nome }}</span
                      >
                    </div>
                  </div>
                  <div>
                    <q-btn
                      icon="close"
                      dense
                      flat
                      round
                      color="red"
                      class="q-ml-sm"
                      :disable="disableAcessorio"
                      @click="excluirAcessorio(acessorio.uuid)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai">TEM CERTEZA QUE DESEJA EXCLUIR?</span>
          <span class="texto-excluir-filho text-brand-5 q-mt-md q-mb-lg">
            Ao clicar em Excluir você estará deletando por definitivo o
            ativo.</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Excluir"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="excluirAtivo()"
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Cancelar"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import InputFormatarPreco from "./InputFormatarPreco.vue";
import SelecaoGrupo from "./SelecaoGrupo.vue";
import SelecaoSubgrupo from "./SelecaoSubgrupo.vue";
import SelecaoChecklist from "./SelecaoChecklist.vue";
import ComponenteFiltros from "./ComponenteFiltros.vue";
import SelecaoFornecedor from "./SelecaoFornecedor.vue";

const columnsDeletado = [
  {
    name: "unidade",
    label: "Unidade",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: true,
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    sortable: true,
    required: true,
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
    sortable: true,
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
    sortable: true,
  },
  {
    name: "subgrupo",
    label: "Sub grupo",
    align: "left",
    sortable: true,
  },
  {
    name: "status",
    label: "Status",
    align: "left",
    sortable: true,
  },
  {
    name: "excluidoPor",
    label: "Excluido Por",
    align: "left",
  },
  {
    name: "excluidoEm",
    label: "Excluido Em",
    align: "left",
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
  },
  {
    name: "historico",
    label: "Histórico",
    align: "left",
  },
];
export default {
  components: {
    SelecaoGrupo,
    SelecaoSubgrupo,
    SelecaoChecklist,
    ComponenteFiltros,
    InputFormatarPreco,
    SelecaoFornecedor,
  },
  props: ["titulo"],
  setup(props) {
    const store = useStore();
    const quasar = useQuasar();

    const catalogoUuid = salvarCatalogoUuid();
    const listaFerramentas = ref([]);
    let rightDrawerOpen = ref(false);
    const editarAtivo = ref({});
    const pagination = ref({
      sortBy: "descricao",
      descending: true,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);
    let disableAtributo = ref(false);
    let disableChecklist = ref(false);
    const imageUrl = ref("");
    const img = ref(null);
    let confirm = ref(false);
    const ativoIdExcluir = ref("");
    const atributosFerramentas = ref([{ chave: "", valor: "" }]);
    const options = ref({
      checklist: [],
    });
    const tab = ref("inicio");
    const subTab = ref("associar");
    const dadoAtributo = ref([{ chave: "", valor: "" }]);
    const dadoAcessorio = ref([{ nome: "" }]);
    const listaChecklist = ref([]);
    const checklist = ref({ checkListUuid: "" });
    const checklistCriar = ref({ nome: "", descricao: "" });
    const resetarChecklist = ref(0);
    const permissaoEditar = ref(false);
    const filtros = ref({});
    const urlImagem = ref("");
    const grupo = ref({});
    const subGrupo = ref({ catalogoSubGrupoUuid: null });
    const dadosEditar = ref({});
    let disableAcessorio = ref(false);
    const igual = ref(false);
    const valorOrdenacao = ref("");
    const acessorioFerramenta = ref([]);
    const columns = ref([
      {
        name: "unidade",
        label: "Unidade",
        align: "left",
      },
      {
        name: "codigo",
        label: "Código",
        align: "left",
        sortable: true,
      },
      {
        name: "descricao",
        label: "Descrição",
        align: "left",
        field: "descricao",
        sortable: true,
        required: true,
      },
      {
        name: "patrimonio",
        label: "Patrimônio",
        align: "left",
        sortable: true,
      },
      {
        name: "grupo",
        label: "Grupo",
        align: "left",
        sortable: true,
      },
      {
        name: "subgrupo",
        label: "Sub grupo",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Status",
        align: "left",
        sortable: true,
      },
      {
        name: "imagem",
        label: "Imagem",
        align: "left",
      },
      {
        name: "historico",
        label: "Histórico",
        align: "left",
      },
      {
        name: "documento",
        label: "Documentos",
        align: "left",
      },
      {
        name: "detalhe",
        label: "Detalhe",
        align: "center",
      },
      {
        name: "excluir",
        label: "Excluir",
        align: "center",
      },
    ]);

    const columnsFornecedor = ref([
      {
        name: "unidade",
        label: "Última Unidade",
        align: "left",
      },
      {
        name: "codigo",
        label: "Código",
        align: "left",
        sortable: true,
      },
      {
        name: "descricao",
        label: "Descrição",
        align: "left",
        sortable: true,
        required: true,
      },
      {
        name: "patrimonio",
        label: "Patrimônio",
        align: "left",
        sortable: true,
      },
      {
        name: "grupo",
        label: "Grupo",
        align: "left",
        sortable: true,
      },
      {
        name: "subgrupo",
        label: "Sub grupo",
        align: "left",
        sortable: true,
      },
      {
        name: "fornecedor",
        label: "Fornecedor",
        align: "left",
      },
      {
        name: "fornecedorCnpj",
        label: "Fornecedor CNPJ",
        align: "left",
      },
      {
        name: "status",
        label: "Status",
        align: "left",
        sortable: true,
      },
      {
        name: "imagem",
        label: "Imagem",
        align: "left",
      },
      {
        name: "historico",
        label: "Histórico",
        align: "left",
      },
      {
        name: "documento",
        label: "Documentos",
        align: "left",
      },
      {
        name: "detalhe",
        label: "Detalhe",
        align: "center",
      },
    ]);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarAtivo = async (
      page = 1,
      rowsPerPage = 10,
      ordenacao = { nome: "desc" }
    ) => {
      disable.value = true;
      loading.value = true;

      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          ordenacao: ordenacao,
          perPage: rowsPerPage,
          page: page,
          unidadeId: filtros.value.unidade?.id,
          catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
          comAcessorios: "sim",
          codigo: filtros.value?.codigo,
          patrimonio: filtros.value.patrimonio,
          status: filtros.value?.statusMovimentacao?.status,
          comCheckLists: "sim",
          comAtributos: "sim",
          nome: filtros.value?.descricao,
          nomeGrupo: filtros.value?.grupo?.nome,
          nomeSubgrupo: filtros.value?.subgrupo?.nome,
          comFornecedorAlocado: props.titulo == "externo" ? "sim" : undefined,
          excluido: props.titulo == "deletado" ? "sim" : undefined,
          comItemsDeletados: props.titulo == "deletado" ? "sim" : undefined,
          fornecedorAlocado:
            props.titulo == "externo"
              ? filtros.value?.fornecedor?.parceiroId
              : undefined,
        });
        listaFerramentas.value = response.response.data.resultado.dados;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;

        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
        disable.value = false;
        loading.value = false;
      }
    };

    const receberGrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.grupo = "";
        return;
      }
      filtros.value.grupo = value;
    };

    const receberSubgrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.subgrupo = "";
        return;
      }
      filtros.value.subgrupo = value;
    };

    const listarAtributoAtivo = async () => {
      disableAtributo.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarAtributoAtivo",
          {
            ativoUuid: editarAtivo.value.ativoUuid,
          }
        );
        atributosFerramentas.value = response.response.data.resultado.dados;
        disableAtributo.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarAcessorioAtivo = async () => {
      disableAcessorio.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          unidadeId: store.state.org.unidadeData.id,
          ativoUuid: editarAtivo.value.ativoUuid,
          comAcessorios: "sim",
        });
        editarAtivo.value.acessorios =
          response.response.data.resultado.dados[0].acessorios;
        disableAcessorio.value = false;
      } catch (error) {
        console.log(error);
        disableAcessorio.value = false;
      }
    };

    const excluirAtributo = async (chaveAtributo) => {
      try {
        await store.dispatch("ferramentaria/excluirAtributoAtivo", {
          ativoUuid: editarAtivo.value.ativoUuid,
          chaveAtributo,
        });
        listarAtributoAtivo();
        quasar.notify({
          message: "Atributo excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir atributo.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirAcessorio = async (acessorioUuid) => {
      try {
        await store.dispatch("ferramentaria/excluirAcessorioAtivo", {
          acessorioUuid,
          ativoUuid: editarAtivo.value.ativoUuid,
        });
        listarAcessorioAtivo();
        quasar.notify({
          message: "Acessório excluido com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir acessório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarAtributo = async () => {
      if (
        validacaoCaracteresEspeciais(dadoAtributo.value[0].chave) != true ||
        validacaoCaracteresEspeciais(dadoAtributo.value[0].valor) != true
      ) {
        return;
      }
      disableAtributo.value = true;
      try {
        await store.dispatch("ferramentaria/adicionarAtributoAtivo", {
          ativoUuid: editarAtivo.value.ativoUuid,
          atributos: dadoAtributo.value,
        });
        listarAtributoAtivo();
        resetVariaveisAtributo();
        quasar.notify({
          message: "Atributo criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableAtributo.value = false;
      } catch (error) {
        quasar.notify({
          message: error.response.data.erros.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableAtributo.value = false;
      }
    };

    const validacaoCaracteresChecklist = (val) => {
      const regex = /^[a-zA-ZÀ-ÖØ-öØ-ÿ?Çç\s]*$/;

      if (!regex.test(val)) {
        return "Caracteres especiais não são permitidos.";
      } else {
        return true;
      }
    };

    const resetVariaveisAtributo = () => {
      dadoAtributo.value = [{ chave: "", valor: "" }];
    };

    const resetVariaveisAcessorio = () => {
      dadoAcessorio.value = [{ nome: "" }];
    };

    const receberChecklist = (value) => {
      checklist.value = value;
    };

    const associarChecklist = async (checkListUuid) => {
      if (checkListUuid === "" || checkListUuid === undefined) {
        quasar.notify({
          message: "Selecione um checklist para associar.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      disableChecklist.value = true;
      try {
        await store.dispatch("ferramentaria/associarCheckListAtivo", {
          ativoUuid: editarAtivo.value.ativoUuid,
          checklListUuid: checkListUuid,
        });
        quasar.notify({
          message: "Checklist associado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarChecklistAtivo();
        resetarChecklist.value++;
      } catch (error) {
        disableChecklist.value = false;
        if (error.response?.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          error.response?.data?.erro?.mensagem ==
          `O checklist [${checkListUuid}] já está associado a este item [${editarAtivo.value.uuid}].`
        ) {
          quasar.notify({
            message: `O Checklist: ${checklist.value.nome} já esta associado a ferramenta.`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        if (error.response?.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        disableChecklist.value = false;
      }
    };

    const desassociarChecklist = async (checklListUuid) => {
      disableChecklist.value = true;
      try {
        await store.dispatch("ferramentaria/desassociarCheckListAtivo", {
          ativoUuid: editarAtivo.value.ativoUuid,
          checklListUuid: checklListUuid,
        });
        quasar.notify({
          message: "Checklist desassociado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        checklist.value = "";
        listarChecklistAtivo();
      } catch (error) {
        disableChecklist.value = false;
        if (error.response.data.erros.mensagem) {
          quasar.notify({
            message: error.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const listarChecklistAtivo = async () => {
      disableChecklist.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarChecklist", {
          catalogoUuid: catalogoUuid.catalogoUuid.value,
          per_page: 100,
          page: 1,
          ativoUuid: editarAtivo.value.ativoUuid,
        });
        listaChecklist.value = response.data.resultado.dados;
        disableChecklist.value = false;
      } catch (error) {
        disableChecklist.value = false;
        console.log(error);
      }
    };

    const excluirAtivo = async () => {
      disable.value = true;
      try {
        await store.dispatch("ferramentaria/excluirAtivo", {
          ativoUuid: ativoIdExcluir.value,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
          usuarioMatricula: store.state.autenticacao.usuarioLogado.id,
        });
        quasar.notify({
          message: "Ativo excluído com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarAtivo();
      } catch (error) {
        disable.value = false;
        if (error.response.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem == "Recurso não autorizado!") {
          quasar.notify({
            message: "Você não tem permissão para deletar o ativo.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const criarChecklist = async () => {
      if (validacaoCaracteresChecklist(checklistCriar.value.nome) != true) {
        return;
      }
      if (checklistCriar.value.nome === "") {
        quasar.notify({
          message: "O nome é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/adicionarChecklist",
          {
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            nome: checklistCriar.value.nome,
            descricao: checklistCriar.value.nome,
            usuarioId: store.state.autenticacao.usuarioLogado.id,
            usuarioNome: store.state.autenticacao.usuarioLogado.nome,
          }
        );
        quasar.notify({
          message: "Checklist criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        checklist.value.checkListUuid = response.data.resultado.checkListUuid;
        resetVariaveisChecklistCriar();
        associarChecklist(checklist.value.checkListUuid);
      } catch (error) {
        if (error.response?.data?.erros.mensagem) {
          quasar.notify({
            message: error.response.data.erros.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error?.response?.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const excluirImagem = async () => {
      editarAtivo.value.urlImagem = "";
    };

    const resetVariaveisChecklistCriar = () => {
      checklistCriar.value = {
        nome: "",
      };
    };

    const receberFornecedor = (value) => {
      editarAtivo.value.fornecedorNome = value?.nome;
      editarAtivo.value.fornecedorCnpj = value?.cnpj;
      editarAtivo.value.fornecedorId = value?.parceiroId || value?.id;
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarAtivo();
    };

    const verificarPermissaoEditar = () => {
      if (
        store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
          "atv-ativo-editar"
        ) != -1 &&
        props.titulo == "interno"
      ) {
        permissaoEditar.value = true;
      }
    };

    const resetVariaveisModal = () => {
      atributosFerramentas.value = [];
      listaChecklist.value = [];
      editarAtivo.value = {};
      img.value = null;
      imageUrl.value = "";
      tab.value = "inicio";
      checklistCriar.value = {
        nome: "",
        descricao: "",
      };
      atributosFerramentas.value = [
        {
          chave: "",
          valor: "",
        },
      ];
      checklist.value = "";
      urlImagem.value = "";
      grupo.value = {};
      subGrupo.value = { catalogoSubGrupoUuid: null };
    };

    const editarInformacoesAtivo = async () => {
      try {
        await store.dispatch("ferramentaria/editarAtivo", {
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          ativoUuid: editarAtivo.value.ativoUuid,
          editar: {
            patrimonio: editarAtivo.value.patrimonio,
            fornecedorId:
              editarAtivo.value.fornecedorId || editarAtivo.value.id,
            preco: editarAtivo.value.preco,
            valorLocacao: editarAtivo.value.valorLocacao,
            tempoPermanencia: parseInt(editarAtivo.value.tempoPermanencia),
          },
        });
        await fazerUploadImagem();
        rightDrawerOpen.value = false;
        quasar.notify({
          message: "Ativo editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarAtivo();
      } catch (error) {
        quasar.notify({
          message: error?.response?.data?.erros?.mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const fazerUploadImagem = async () => {
      if (
        (img.value?.name == "" || img.value?.name == undefined) &&
        editarAtivo.value.urlImagem != ""
      ) {
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/receberUrlUploadAtivo",
          {
            ativoUuid: editarAtivo.value.ativoUuid,
            nomeArquivo: img.value.name,
          }
        );

        let formAttributes =
          response.response.data.resultado.dados.formAttributes;
        let formInputs = response.response.data.resultado.dados.formInputs;
        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        formData.append("file", img.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        request.send(formData);
        urlImagem.value = `${formAttributes.action}/${formInputs.key}`;
        editarImagemAtivo(urlImagem.value);
      } catch (error) {
        console.log(error);
      }
    };

    const editarImagemAtivo = async (urlImagem) => {
      try {
        await store.dispatch("ferramentaria/alterarImagemAtivo", {
          ativoUuid: editarAtivo.value.ativoUuid,
          urlImagem,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
        });
        if (editarAtivo.value?.status != "disponivel") {
          rightDrawerOpen.value = false;
          listarAtivo();
        }
      } catch (error) {
        console.log(error);
      }
    };

    const receberGrupo = (value) => {
      grupo.value = value;
    };

    const receberSubgrupo = (value) => {
      subGrupo.value = value;
    };

    const verificarCliente = () => {
      if (
        store.state.autenticacao.cliente.indexOf("wilsonsons") == -1 &&
        store.state.autenticacao.cliente.indexOf("staging-wilsonsons") == -1 &&
        store.state.autenticacao.cliente.indexOf("staging-multpex") == -1
      ) {
        columns.value = columns.value.filter(
          (coluna) => coluna.name != "documento"
        );
        columnsFornecedor.value = columnsFornecedor.value.filter(
          (coluna) => coluna.name != "documento"
        );
      }
    };

    const validacaoCaracteresEspeciais = (val) => {
      const regex = /[^a-zA-Z0-9\s]/g;

      if (regex.test(val)) {
        return "Caracteres especiais não são permitidos.";
      } else {
        return true;
      }
    };

    const adicionarAcessorio = async () => {
      if (validacaoCaracteresEspeciais(dadoAcessorio.value[0].nome) != true) {
        return;
      }
      disableAcessorio.value = true;
      try {
        await store.dispatch("ferramentaria/adicionarAcessorioAtivo", {
          ativoUuid: editarAtivo.value.ativoUuid,
          acessorios: dadoAcessorio.value,
        });
        listarAcessorioAtivo();
        resetVariaveisAcessorio();
        quasar.notify({
          message: "Acessório adicionado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disableAcessorio.value = false;
      } catch (error) {
        if (error.response.data.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    watch(
      () => img.value,
      () => {
        if (img.value == null) {
          return;
        }
        if (img.value == null || !img.value.type.includes("image")) {
          quasar.notify({
            message: "Selecione uma imagem",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          img.value = null;
          return;
        }
        let fileReader = new FileReader();
        fileReader.readAsDataURL(img.value);
        fileReader.addEventListener("load", () => {
          imageUrl.value = fileReader.result;
          editarAtivo.value.urlImagem = fileReader.result;
        });
      }
    );

    watch(
      () => img.value,
      () => {
        if (editarAtivo.value.urlImagem != null && img.value.name) {
          editarAtivo.value.urlImagem = "";
        }
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value == false) {
          resetVariaveisModal();
          return;
        }
        listarAtributoAtivo();
        listarChecklistAtivo();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarAtivo(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => filtros.value?.unidade,
      () => {
        listarAtivo();
      }
    );

    watch(
      () => editarAtivo?.value?.tempoPermanencia,
      (atual, antigo) => {
        if (atual?.length > 6 && antigo?.length == 6) {
          quasar.notify({
            message: `O campo "Tempo de Permanência" não pode ter mais que 6 digitos.`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          editarAtivo.value.tempoPermanencia = antigo;
        }
      }
    );

    onMounted(() => {
      verificarCliente();
      listarAtivo();
      verificarPermissaoEditar();
    });

    const handleRequest = async (value) => {
      const ordenacao = {};

      if (valorOrdenacao.value == value.pagination.sortBy) {
        igual.value = !igual.value;
        ordenacao[
          valorOrdenacao.value == "descricao" ? "nome" : valorOrdenacao.value
        ] = igual.value ? "asc" : "desc";

        pagination.value.sortBy = valorOrdenacao.value;
        pagination.value.descending = igual.value ? false : true;

        listarAtivo(
          pagination.value.page,
          pagination.value.rowsPerPage,
          ordenacao
        );
        return;
      }

      igual.value = false;

      valorOrdenacao.value = value.pagination.sortBy;
      pagination.value.sortBy = valorOrdenacao.value;
      pagination.value.descending = true;

      ordenacao[
        valorOrdenacao.value == "descricao" ? "nome" : valorOrdenacao.value
      ] = "desc";
      listarAtivo(
        pagination.value.page,
        pagination.value.rowsPerPage,
        ordenacao
      );
    };

    return {
      columns,
      columnsDeletado,
      listarAtivo,
      listaFerramentas,
      rightDrawerOpen,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      img,
      imageUrl,
      confirm,
      ativoIdExcluir,
      subTab,
      atributosFerramentas,
      options,
      disable,
      tab,
      listarAtributoAtivo,
      permissaoEditar,
      receberGrupoFiltro,
      receberSubgrupoFiltro,
      editarInformacoesAtivo,
      excluirAtributo,
      disableAtributo,
      handleRequest,
      disableChecklist,
      adicionarAtributo,
      excluirAtivo,
      dadoAtributo,
      receberChecklist,
      listarChecklistAtivo,
      receberFornecedor,
      valorOrdenacao,
      listaChecklist,
      verificarPermissaoEditar,
      associarChecklist,
      checklist,
      desassociarChecklist,
      checklistCriar,
      columnsFornecedor,
      resetarChecklist,
      editarAtivo,
      resetVariaveisModal,
      criarChecklist,
      store,
      filtros,
      fazerUploadImagem,
      urlImagem,
      excluirImagem,
      loading,
      grupo,
      subGrupo,
      receberGrupo,
      receberSubgrupo,
      catalogoUuid,
      listarAcessorioAtivo,
      acessorioFerramenta,
      disableAcessorio,
      dadoAcessorio,
      adicionarAcessorio,
      excluirAcessorio,
      resetVariaveisAcessorio,
      dadosEditar,
      mobile,
      validacaoCaracteresEspeciais,
      receberFiltro,
      validacaoCaracteresChecklist,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 500px;
}
.container-tabela {
  margin-top: 10px;
}
tbody tr td {
  white-space: pre-wrap;
}
.input-filtro-container {
  margin-top: 29px;
}
container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: 100%;
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 30;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
a {
  text-decoration: none;
}
input[type="file"] {
  display: none;
}
.imagem-ferramenta-container {
  border: 1px solid black;
}
.imagem-ferramenta {
  width: 100%;
  height: 200px;
}
.container-imagem {
  height: 210px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #707070;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}
.file-container {
  width: 100%;
  background: transparent;
  z-index: 30 !important;
}
.texto-alterar-imagem {
  color: black !important;
  z-index: 31;
  cursor: pointer;
  transition: all 0.5s;
}
.texto-alterar-imagem:hover {
  transform: scale(1.2);
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.icon {
  margin-top: 26px;
}
.espaco {
  margin-top: 1px;
}
.texto-titulo-modal {
  font-size: 16px;
}
.file {
  height: 180px;
}
.container-grid-table {
  border: 1px solid black;
  font-size: 12px;
}
.container-imagem-grid {
  border: 1px solid black;
  border-radius: 5px;
}
.tab-mobile {
  font-size: 1px !important;
}
.icon-modal {
  font-size: 22px;
}
.container-modal-excluir {
  width: 590px;
}
.texto-titulo-tabela {
  font-size: 14px;
  margin-bottom: 10px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .container-btn-cadastro {
    margin: 17px 0px 0px 0px;
  }
  .btn-cadastro {
    font-size: 13px;
  }
  .container-tab {
    margin: 10px 0px 0px 0px;
  }
  .icon-modal {
    font-size: 19px;
    margin-right: 3px;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input-modal {
    font-size: 12px;
  }
  .btn-modal {
    font-size: 13px;
  }
  .imagem-ferramenta {
    width: 100%;
    height: 150px;
  }
  .container-imagem {
    height: 150px;
  }
  .texto-alterar-imagem {
    font-size: 10px;
  }
  .file {
    height: 120px;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
  .input-mobile {
    font-size: 12px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 14px;
  }
  .texto-titulo-tabela {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .texto-conteudo-tabela {
    font-size: 12px;
    max-width: 80%;
    word-wrap: break-word;
  }
  .icon-tabela {
    font-size: 12px;
  }
  .imagem-ferramenta {
    width: 100%;
    height: 150px;
  }
}
</style>
